import React from 'react'
import { CompactTable } from '@/components/Table'
import { Spinner } from '@/components/Spinner'
import { useQuery } from '@tanstack/react-query'
import { foodRestrictionsQuery } from '@/api'

export default function FoodRestrictionsIndex() {
  const { data: foodRestrictions } = useQuery(foodRestrictionsQuery)

  return (
    <div style={{ paddingTop: '20px' }}>
      <div className="viewHeader row">
        {/* {isAdmin && (
          <div className="viewHeader-controls col-md-4">
            <Button asChild variant="primary">
              <Link to="/food-restrictions/new">Create Food Restriction</Link>
            </Button>
          </div>
        )} */}
      </div>

      <div id="foodGroupTable">
        {foodRestrictions ? (
          <CompactTable
            aria-label="Food restrictions"
            columns={[
              { label: 'Name', key: 'name' },
              { label: 'Enabled', key: 'enabled', width: 100 },
            ]}
            rows={foodRestrictions as any[]}
            onLinkAction={(row) => {
              return `/food-restrictions/${row.idFoodRestriction}`
            }}
          />
        ) : (
          <div className="well">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  )
}
